import { render, staticRenderFns } from "./SalaryMainReport.vue?vue&type=template&id=51c5530b&scoped=true&"
import script from "./SalaryMainReport.vue?vue&type=script&lang=js&"
export * from "./SalaryMainReport.vue?vue&type=script&lang=js&"
import style0 from "./SalaryMainReport.vue?vue&type=style&index=0&id=51c5530b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c5530b",
  null
  
)

export default component.exports